export default __webpack_public_path__ + "static/media/flipper.e83dc53d.png";